import React from 'react';
import _ from 'lodash';
import { defineMessages } from 'react-intl';
import { loadFavoriteCourses, loadFollowedDiscussions, } from '../../../actions/auth';
import Layout from '../../../components/Layout/Layout';
import { isTrial, ssrRequest } from '../../../helpers';
import isLoggedIn from '../../../helpers/checkAuth';
import notAuthorized from '../../not-authorized';
import notFound from '../../not-found/index';
import CourseDetailsManageTab from './CourseDetailsManageTab';
import { getCourseBySlug, getCourseTextNotes, getCourseVideoNotes, } from '../../../actions/courseDetails';
import { getDiscussions } from '../../../actions/discussions';
const messages = defineMessages({
    coursesTitle: {
        id: 'CourseDetailsManageTab.title',
        defaultMessage: 'Manage - {name} - Course',
        description: 'Title displayed in Course detail manage page',
    },
});
async function action(context) {
    const { store, params, fetch, intl: { formatMessage }, } = context;
    const { courseSlug } = params;
    const { auth } = store.getState();
    if (!isLoggedIn(auth)) {
        return notAuthorized(context);
    }
    if (isTrial(auth)) {
        return notFound(context);
    }
    await store.dispatch({
        type: getCourseBySlug(courseSlug).types[0],
    });
    try {
        const res = await getCourseBySlug(courseSlug).promise(fetch);
        const resText = await res.text();
        const json = resText ? JSON.parse(resText) : {};
        if (res.status !== 200) {
            if ([403, 404].includes(res.status)) {
                return notFound(context);
            }
            await store.dispatch({
                error: json,
                type: getCourseBySlug(courseSlug).types[2],
            });
        }
        else {
            const result = {
                status: res.status,
                json,
            };
            await store.dispatch({
                result,
                type: getCourseBySlug(courseSlug).types[1],
            });
        }
    }
    catch (error) {
        const middlewareError = new Error(`MIDDLEWARE ERROR: ${error?.message}`);
        middlewareError.stack = error?.stack;
        console.error(middlewareError);
        await store.dispatch({
            error,
            type: getCourseBySlug(courseSlug).types[2],
        });
    }
    const { courseDetails } = store.getState();
    const courseId = _.get(courseDetails, 'course._id');
    const title = formatMessage(messages.coursesTitle, {
        name: _.get(courseDetails, 'course.name', ''),
    });
    const promises = [];
    promises.push(async () => store.dispatch(loadFollowedDiscussions()));
    promises.push(async () => store.dispatch(loadFavoriteCourses()));
    promises.push(async () => {
        await store.dispatch({
            type: getCourseTextNotes(courseId).types[0],
        });
        try {
            const res = await getCourseTextNotes(courseId).promise(fetch);
            const resText = await res.text();
            const json = resText ? JSON.parse(resText) : {};
            if (res.status !== 200) {
                if ([403, 404].includes(res.status)) {
                    return notFound(context);
                }
                return store.dispatch({
                    error: json,
                    type: getCourseTextNotes(courseId).types[2],
                });
            }
            const result = {
                status: res.status,
                json,
            };
            return store.dispatch({
                result,
                type: getCourseTextNotes(courseId).types[1],
            });
        }
        catch (error) {
            const middlewareError = new Error(`MIDDLEWARE ERROR: ${error?.message}`);
            middlewareError.stack = error?.stack;
            console.error(middlewareError);
            return store.dispatch({
                error,
                type: getCourseTextNotes(courseId).types[2],
            });
        }
    });
    promises.push(async () => {
        await store.dispatch({
            type: getCourseVideoNotes(courseSlug).types[0],
        });
        try {
            const res = await getCourseVideoNotes(courseSlug).promise(fetch);
            const resText = await res.text();
            const json = resText ? JSON.parse(resText) : {};
            if (res.status !== 200) {
                if ([403, 404].includes(res.status)) {
                    return notFound(context);
                }
                return store.dispatch({
                    error: json,
                    type: getCourseVideoNotes(courseSlug).types[2],
                });
            }
            const result = {
                status: res.status,
                json,
            };
            return store.dispatch({
                result,
                type: getCourseVideoNotes(courseSlug).types[1],
            });
        }
        catch (error) {
            const middlewareError = new Error(`MIDDLEWARE ERROR: ${error?.message}`);
            middlewareError.stack = error?.stack;
            console.error(middlewareError);
            return store.dispatch({
                error,
                type: getCourseVideoNotes(courseSlug).types[2],
            });
        }
    });
    promises.push(async () => {
        const query = {
            page: 1,
            sort: '-createDate',
            search: '',
            perPage: 50,
            courseId: courseSlug,
        };
        return ssrRequest({
            getAction: getDiscussions.bind(this, query),
            fetch,
            store,
        });
    });
    await Promise.all(promises.map(promise => promise()));
    return {
        chunks: ['course-details'],
        title,
        component: (React.createElement(Layout, { context: context },
            React.createElement(CourseDetailsManageTab, { data: {}, title: title }))),
    };
}
export default action;
